<h1 class="text-4xl font-extrabold text-default">
  {{ "Choose the employees you'd like to keep" | translate }}
</h1>
<div class="text-xl font-medium text-default">
  {{
    "Leave the employees you'd like to keep selected — up to [limit] — and deselect the rest to fit within your [planName] plan."
      | translate: { limit: seatsLimit(), planName: planName() }
  }}
</div>

@if (projectedPlanQuotas()[quotaType.SEATS]) {
  <div class="sticky top-0 z-sticky bg-surface py-md">
    <div sbCard>
      <div class="flex flex-col p-md">
        <app-quota-card-rule [quotaType]="quotaType.SEATS" [subscriptionPlanQuotas]="projectedPlanQuotas()" />
      </div>
    </div>
  </div>
}

<div>
  <p class="font-medium text-default">
    @if (isOverLimit()) {
      @if (overLimitBy() === 1) {
        {{ 'Deselect at least 1 more employee to continue.' | translate }}
      } @else {
        {{ 'Deselect at least [count] more employees to continue.' | translate: { count: overLimitBy() } }}
      }
    } @else {
      {{ 'Your team fits within the plan.' | translate }}
    }
  </p>
</div>

<div class="mb-32 flex flex-col gap-sm">
  @for (employee of employees(); track employee.id) {
    <div [sbTooltip]="isSelf(employee.id) ? ('You can’t deactivate your own account.' | translate) : undefined">
      <sb-checkbox
        data-hj-suppress
        [checked]="isSelected(employee.id)"
        [disabled]="isSelf(employee.id)"
        (change)="toggleSelection(employee.id)"
      >
        {{ employee.name }}
      </sb-checkbox>
    </div>
  } @empty {
    <p class="text-subtle">{{ 'There are no active employees to deactivate.' | translate }}</p>
  }
</div>

<div
  class="fixed bottom-0 left-0 flex h-full max-h-32 w-full flex-col items-center justify-center gap-md border-0 border-t border-solid border-subtle bg-surface shadow-2xl"
>
  <button sb-button [disabled]="!canContinue()" [color]="'primary'" class="w-full max-w-2xl" (click)="continue()">
    {{ 'Continue' | translate }}
  </button>
  <button sb-button [color]="'secondary'" class="w-full max-w-2xl" (click)="back.emit()">
    {{ 'Back to organization structure' | translate }}
  </button>
  <p class="mb-0 font-semibold text-default">
    {{ 'Changed your mind?' | translate }}
    <a
      [routerLink]="[
        '',
        { outlets: { modal: ['billing', 'plan-wizard', { originator: 'schedule-downgrade-quota-flow' }] } },
      ]"
      [queryParams]="{ upgrade: true }"
    >
      <span class="text-brand">
        {{ 'Upgrade your plan' | translate }}
      </span>
    </a>
  </p>
</div>
